// test247
(247 && 0);
